<template>
  <div>
    <div style="padding: 6px;">
      <span style="font-size:16px;padding-left: 14px;">
        <i style="display: inline-block; width: 18px;height: 18px;position: relative;top: 3px;">
          <img style="width: 100%;height: 100%;" src="@/assets/tag.png" alt="">
        </i>
        {{ $t('message.title.whereUsed') }}
      </span>
    </div>


    <div style="padding: 10px 20px;  ">
      <!-- 表格区域 -->
      <vxe-grid ref='xGrid' v-bind="gridOptions" @cell-dblclick="noEdit"></vxe-grid>
    </div>

    <div style="padding: 6px;">
      <span style="font-size:16px;padding-left: 14px;">
        <i style="display: inline-block; width: 18px;height: 18px;position: relative;top: 3px;">
          <img style="width: 100%;height: 100%;" src="@/assets/tag.png" alt="">
        </i>
        {{ $t('message.title.PGWhereUsed') }}
      </span>
    </div>


    <div style="padding: 10px 20px;">
      <!-- 表格区域 -->
      <vxe-grid ref='xGridReleasedChange' v-bind="gridOptions2" @cell-dblclick="noEdit"></vxe-grid>
    </div>

    <el-dialog v-if="cascaderShow" class="searchAddBomList" :title="$t('message.title.add')"
      :visible.sync="cascaderShow" @close="closeCascaderShow">
      <div style="height:270px;">
        <div style="margin:60px auto;padding-left:50px">
          <el-cascader v-model="cascaderValue" :options="cascaderList" :props="cascaderProps" :show-all-levels="true"
            size="small" ref="cascaderAddr" style="width:75%"></el-cascader>
          <el-button size="small" type="primary" style="margin-left:10px" @click="getCascadeValue">{{
            $t("message.button.affirm") }}</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<style></style>

<style scoped></style>

<script>

import axios from "axios";
export default {
  data() {
    return {
      gridOptions: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: 'id',
        height: "300",
        size: "small",
        data: [],
        sortConfig: {
          trigger: 'cell'
        },
      },
      gridOptions2: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: 'id',
        height: "300",
        size: "small",
        data: [],
        sortConfig: {
          trigger: 'cell'
        },
      },

      loading: true,
      rols_text: [], //表体显示内容
      get_change_info: "", //父组件传来的值

      cascaderShow: false,
      cascaderValue: [],
      cascaderList: [],
      cascaderProps: {}
    }
  },
  mounted() { },

  methods: {

    showDetailEvent(row) {
      const obj = {
        id: row.itemId,
        classId: row.itemClassId,
        subClassId: row.itemSubClassId,
        title: row[0]
      };
      this.getLink(obj);
      this.$store.commit('setPageRefresh');
    },
    async getItemWhereUsed() {

      const change_info = this.get_change_info || this.$store.state.change_info;

      var obj_get = { //获取change
        ... this.$store.state.objectId,
        ...change_info,
        tableId: 8
      };
      var loadTableUrl = `/pmdm/items/loadTable${this.params(obj_get)}`;
      const { //获取标题
        data: res
      } = await this.$http.get(loadTableUrl);
      //this.gridOptions.columns = this.getNewTableTitleData(res);
      this.$refs.xGrid.loadColumn(this.getNewTableTitleData(res));
      this.rols_text = this.getNewTableContentData(res);
      //this.gridOptions.data = this.rols_text;
      this.$refs.xGrid.loadData(this.rols_text);

    },
    async getItemPendingChangeWhereUsed() {



      const change_info = this.get_change_info || this.$store.state.change_info;

      var obj_get = { //获取change
        ... this.$store.state.objectId,
        ...change_info,
        tableId: 9
      };
      var loadTableUrl = `/pmdm/items/loadTable${this.params(obj_get)}`;
      const { //获取标题
        data: res
      } = await this.$http.get(loadTableUrl);
      //this.gridOptions2.columns = this.getNewTableTitleData(res);
      this.$refs.xGridReleasedChange.loadColumn(this.getNewTableTitleData(res));
      this.rols_text = this.getNewTableContentData(res);
      //this.gridOptions2.data = this.rols_text;
      this.$refs.xGridReleasedChange.loadData(this.rols_text);

    },
    noEdit({ row, columnIndex }) {
      if (column.editRender.cascaderType && this.editTable) {
        this.cascaderList = column.editRender.cascadeOptions;
        let m = row[[column.property]];
        if (column.editRender.props.multiple) {
          this.cascaderValue = m ? m.map((i) => { return this.getParentIdList(this.cascaderList, i) }) : ''
          this.cascaderProps.multiple = true;
        } else {
          this.cascaderProps.multiple = false;
          this.cascaderValue = m;
        }
        this.cascaderProps.checkStrictly = true;
        this.tempData = { row, column }
        this.cascaderShow = true;
        console.log(this.cascaderValue);
      }
    },
  },
  created() {
    this.getItemWhereUsed();
    this.getItemPendingChangeWhereUsed();
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },

};
</script>